import type { GetProjectQuery } from '@/survey-graphql';

import SurveyAiFormsAiSectionQuestionRenderer from './survey-ai-forms-ai-section-question-renderer';
import type { FormAnswerValue, ResponseMode } from './survey-ai-forms.types';

type ProjectQuestion = NonNullable<
  GetProjectQuery['project']
>['questions'][number];

interface Props {
  question: ProjectQuestion;
  questionValue: FormAnswerValue | undefined;
  transcriptValue: string;
  openEndedDisplayValue: string;
  onQuestionValueChange: (value: FormAnswerValue) => void;
  onOpenEndedChange: (value: string) => void;
  onTranscriptChange: (value: string) => void;
  onSubmit: () => void;
  onNext: () => void;
  hasValue: boolean;
  responseMode: ResponseMode;
  loading: boolean;
  isMobile?: boolean;
  isUserVoiceEnabled?: boolean;
}

export default function SurveyAiFormsMobileQuestionRenderer({
  question,
  questionValue,
  transcriptValue,
  openEndedDisplayValue,
  onQuestionValueChange,
  onOpenEndedChange,
  onTranscriptChange,
  onSubmit,
  onNext,
  hasValue,
  responseMode,
  loading,
  isMobile = false,
  isUserVoiceEnabled = false,
}: Props) {
  return (
    <div className='w-full' data-test='mobile-question-renderer'>
      <SurveyAiFormsAiSectionQuestionRenderer
        question={question}
        questionValue={questionValue}
        transcriptValue={transcriptValue}
        openEndedDisplayValue={openEndedDisplayValue}
        onQuestionValueChange={onQuestionValueChange}
        onOpenEndedChange={onOpenEndedChange}
        onTranscriptChange={onTranscriptChange}
        onSubmit={onSubmit}
        onNext={onNext}
        hasValue={hasValue}
        responseMode={responseMode}
        loading={loading}
        isMobile={isMobile}
        isUserVoiceEnabled={isUserVoiceEnabled}
      />
    </div>
  );
}
